import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";
import { orderIdZodSchema } from "../../order-id";
import { financialOrderInformationForCustomerProjectionIdZodSchema } from "./financial-order-information-for-customer-id";
import { receiptForCustomerZodObject } from "./receipt-for-customer";

const financialOrderInformationForCustomerProjectionZodObject = z.object({
    _id: financialOrderInformationForCustomerProjectionIdZodSchema,
    _type: z.literal("ORDER_HISTORY_FOR_CUSTOMER_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    status: z.enum(["PENDING", "SETTLED"]),
    current: z.object({
        /** Amount paid by customer */
        amountSettled: z.number().int(),
        /** Amount reserved of customers money but not drawn yet */
        amountCapturable: z.number().int(),
        /** Amount not yet paid or reserved */
        amountUnsettled: z.number().int(),
        /** Amount refunded to customer */
        amountRefunded: z.number().int(),
        /** Amount about to be refunded to customer */
        amountPendingRefund: z.number().int(),
    }),
    for: z.object({
        providerId: providerIdZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
    }),
    receipts: z.array(receiptForCustomerZodObject),
});

type FinancialOrderInformationForCustomerProjection = z.infer<
    typeof financialOrderInformationForCustomerProjectionZodObject
>;

export { financialOrderInformationForCustomerProjectionZodObject };
export type { FinancialOrderInformationForCustomerProjection };
